import { CatalogGrade } from "@/pages/steel/models/CatalogGrade";
import { getCatalogGrades } from "@/pages/steel/repositories/CatalogGradeRepository";
import { ErrorModal } from "@dexteel/mesf-core";
import { CircularProgress, TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import { FieldError } from "react-hook-form";

type Props = {
	label: string;
	value: number | null;
	onChange?: Function;
	fieldError?: FieldError | undefined;
	disabled?: boolean;
};

export const GradeSelector = ({
	label,
	value,
	onChange = () => {},
	fieldError,
	disabled = false,
}: Props) => {
	const [grades, setGrades] = useState<CatalogGrade[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [error, setError] = useState("");

	const loadData = async () => {
		setIsLoading(true);
		setError("");
		const resp = await getCatalogGrades();
		if (resp.ok) {
			const rows = get(resp, "data.tables[0].rows", []) as CatalogGrade[];
			setGrades(rows);
		} else {
			setError(resp.message);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		loadData().then(() => {});
		return;
	}, []);

	return (
		<>
			<Autocomplete
				id="clear-on-escape"
				clearOnEscape
				options={grades || []}
				getOptionLabel={(option) => option.GradeName}
				isOptionEqualToValue={(option: CatalogGrade, value: CatalogGrade) =>
					option.GradeId === value.GradeId
				}
				disabled={disabled}
				renderInput={(params) => (
					<TextField
						{...params}
						label={label}
						variant="outlined"
						fullWidth
						size="small"
						error={!!fieldError}
						helperText={fieldError?.message}
						InputProps={{
							...params.InputProps,
							endAdornment: (
								<>
									{isLoading ? (
										<CircularProgress color="inherit" size={20} />
									) : (
										params.InputProps.endAdornment
									)}
								</>
							),
						}}
					/>
				)}
				value={grades.find((g) => g.GradeId == value) || null}
				onChange={(event, newValue) => {
					onChange(newValue?.GradeId);
				}}
			/>
			<ErrorModal
				error={error}
				onHide={() => setError("")}
				title="Error loading grades"
			/>
		</>
	);
};
